$(document).ready(function () {
  $('.product_crystal-hair-eraser .qty_swatch input').each(function( index ) {
   if($(this).val() == '2 Pack'){
     $(this).click();
   }
  });

  $(".pro-richtext-reviews").slick({ infinite: !0, slidesToShow: 1, slidesToScroll: 1, arrows: !1, dots: !0, autoplay: !0, autoplaySpeed: 2e3 });

    $(".tab_nav li:first-child").addClass("active");
      $(".tabcontent").hide();
      $(".tabcontent:first").show();
      $(".tab_nav li").click(function () {
          $(".tab_nav li").removeClass("active"), $(this).addClass("active"), $(".tabcontent").hide();
          var e = $(this).find("a").attr("href");
          return $(e).fadeIn(), !1;
      });

              $(".review_main_slider").slick({
                infinite: !0,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: !0,
                autoplay: !0,
                autoplaySpeed: 2e3,
                dots: !1,
                responsive: [
                    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                ],
            });
});

// $(function () {
//     $(".ques-heading").click(function (e) {
//         var t = $(this).closest(".questions__item_row").find(".ques-desc");
//         $(this).closest(".question-body").find(".ques-desc").not(t).slideUp(),
//             $(this).hasClass("active") ? $(this).removeClass("active") : ($(".ques-heading.active").removeClass("active"), $(this).addClass("active")),
//             t.stop(!1, !0).slideToggle(),
//             e.preventDefault();
//     });
// }),
//     $(document).ready(function () {
//             $("a.value-props-btn").click(function (e) {
//                 e.preventDefault(), $(".value-props-modal").css("display", "block"), $("body").css("overflow-y", "hidden");
//             }),
//             $(".close-modal,.modal-sandbox").click(function (e) {
//                 e.preventDefault(), $(".value-props-modal").css("display", "none"), $("body").css("overflow-y", "auto");
//             }),
//             $(".our_iwt_slider").slick({ infinite: !0, slidesToShow: 1, slidesToScroll: 1, arrows: !1, dots: !0, centerMode: !0, centerPadding: "25%", responsive: [{ breakpoint: 576, settings: { centerPadding: "10%" } }] }),

//             $(".beforeafter-carousel").slick({ infinite: !0, slidesToShow: 1, slidesToScroll: 1, arrows: !0, dots: !1, autoplay: !1, autoplaySpeed: 2e3 }),
            
//             $(".brand-carousel").slick({
//                 infinite: !0,
//                 slidesToShow: 4,
//                 slidesToScroll: 1,
//                 arrows: !1,
//                 dots: !1,
//                 responsive: [
//                     { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
//                     { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
//                 ],
//             }),
//             $("a.smooth-redirect").on("click", function (e) {
//                 e.preventDefault();
//                 var t = this.hash,
//                     s = $(t);
//                 $("html, body")
//                     .stop()
//                     .animate({ scrollTop: s.offset().top }, 300, "swing", function () {});
//             }),
//             jQuery(function () {
//                 var e = $(".qty_swatch input:checked+label").find(".var_price").text(),
//                     t = $(".qty_swatch input:checked+label").find(".var_com_price").text();
//                 $(".desk_stcy_price, .stcy_pro_price").text(e),
//                     $(".stcy_compro_price").text(t),
//                     jQuery(".qty_swatch .element").click(function () {
//                         var s = $(this).find(".var_price").text(),
//                             i = $(this).find(".var_price").text();
//                         $(".desk_stcy_price, .stcy_pro_price").text(s), $(".stcy_compro_price").text(i);
//                     });
//             }),
//             $(".sticky_addtocart").click(function () {
//                 $(".product-form__submit").trigger("click");
//             });
//     }),
//     $(window).width() <= 767 &&
//         $(window).scroll(function () {
//             var e = $(window).scrollTop();
//             $(".index_rich_text .gradient").css("background-position", "center " + e + "0px");
//         }),
//     $(document).ready(function () {
//         $(".faq_btn").on("click", function () {
//             $(this).toggleClass("open").next().slideToggle(300);
//         });
//     });
